module.exports = __webpack_public_path__ + "static/media/avc_doc.57f9338d.svg";